import CreatingCase from './CreatingCase';
import CasesList from './CasesList';
import BitdefenderLogo from '../../../base_components/BitdefenderLogo';

import styles from '../../../styles/base_components/Page.module.scss';
import ImportCase from "./ImportCase";

function Cases(props) {
  return (
    <div className={styles.page}>
      <CreatingCase className={styles.group}/>
      <ImportCase className={styles.group}/>
      <CasesList className={styles.group}/>

      <BitdefenderLogo/>
    </div>
  );
}

export default Cases;